<template>
  <div class="app flex-row align-items-center">
    <div class="container">
      <b-row class="justify-content-center">
        <b-col md="8">
          <b-card-group>
            <b-card no-body class="p-4">
              <b-card-body>
                <b-form autcomplete="off" @submit.prevent="submitLoginForm()">
                  <h1>Вход</h1>
                  <p class="text-muted">Войдите в свой аккаунт</p>
                  <b-input-group class="mb-3">
                    <b-input-group-prepend
                      ><b-input-group-text
                        ><i class="icon-user"></i></b-input-group-text
                    ></b-input-group-prepend>
                    <b-form-input
                      type="text"
                      class="form-control"
                      v-model="authorizationData.name"
                      placeholder="Логин"
                      autocomplete="off"
                    />
                  </b-input-group>
                  <b-input-group class="mb-4">
                    <b-input-group-prepend
                      ><b-input-group-text
                        ><i class="icon-lock"></i></b-input-group-text
                    ></b-input-group-prepend>
                    <b-form-input
                      type="password"
                      class="form-control"
                      v-model="authorizationData.password"
                      placeholder="Пароль"
                      autocomplete="off"
                    />
                  </b-input-group>
                  <b-row>
                    <b-col cols="6">
                      <b-button type="submit" variant="primary" class="px-4"
                        >Войти</b-button
                      >
                    </b-col>
                  </b-row>
                </b-form>
              </b-card-body>
            </b-card>
            <b-card
              no-body
              class="text-white bg-primary py-5 d-md-down-none"
              style="width: 44%"
            >
              <b-card-body class="text-center">
                <div>
                  <h2>Справочник</h2>
                  <p>
                    Данный сервис предоставляет каталог справочника для
                    Узбекистана <br />
                    ktru.mf.uz
                  </p>
                </div>
              </b-card-body>
            </b-card>
          </b-card-group>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import { GET, POST } from "@/shared/api";

export default {
  name: "Login",
  data() {
    return {
      authorizationData: {
        name: null,
        password: null,
      },
    };
  },
  methods: {
    submitLoginForm() {
      POST(this.authorizationData, "/login", this).then((response) => {
        localStorage.setItem("check-v1", true);
        localStorage.setItem("authorization", true);
        let user = response.user;
        user.token = response.token;
        localStorage.setItem("user", JSON.stringify(user));
        this.$store.state.user = JSON.parse(localStorage.getItem("user"));
        this.$router.push({ name: "Home" });
      });
    },
  },
};
</script>
